import React from "react";
import { motion } from "framer-motion";

/**
 * Dark, enterprise-style page hero with navbar clearance.
 * Used for the centered hero on inner pages (Services, About, Contact).
 */
const PageHero = ({ eyebrow, title, subtitle, children }) => (
  <section className="relative overflow-hidden bg-brand-gradient-dark px-4 pb-20 pt-32 sm:px-6 sm:pb-24 sm:pt-36 lg:px-8">
    <div className="pointer-events-none absolute -left-24 top-0 h-96 w-96 rounded-full bg-primary/30 blur-3xl" />
    <div className="pointer-events-none absolute -right-24 top-20 h-96 w-96 rounded-full bg-accent/20 blur-3xl" />
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.06),transparent_55%)]" />

    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="relative mx-auto max-w-3xl text-center"
    >
      {eyebrow && (
        <span className="inline-block text-sm font-semibold uppercase tracking-widest text-amber-300">
          {eyebrow}
        </span>
      )}
      <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
        {title}
      </h1>
      {subtitle && <p className="mt-5 text-lg text-purple-100/80">{subtitle}</p>}
      {children}
    </motion.div>
  </section>
);

export default PageHero;
